import React, { useEffect, useState } from "react";
import DropDown from "../TPDropDown";
import {
	SOURCE_TYPE,
	CONSTANT_RECORD_TYPE,
	ACTIONS,
	INDEX,
	SYSTEM_SOURCE_NAME,
	IB_SOURCE_NAME,
} from "../../../constants/loopRecordOptions";
import {
	Box,
	FormControl,
	InputLabel,
	MenuItem,
	Tab,
	Tabs,
	Select,
	Stack,
	Autocomplete,
	TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { eachDeep, filterDeep } from "deepdash-es/standalone";
import { useSelector } from "react-redux";

const OutboundSourceItemOptions = CONSTANT_RECORD_TYPE.OUTBOUND_ITEM.map(
	(e) => e?.value
);

const customDbDefaultValues = [
	{
		"MAPNAME": "SQL_ERROR",
	},
	{
		"MAPNAME": "RESULT_COUNT",
	},
	{
		"MAPNAME": "CURRENT_RECORD_INDEX",
	}
]

const SourceTypeOutboundData = (props) => {
	const { t } = useTranslation();
	const { sourceType, valuesHandler, node, disabled } = props;
	const [sourceName, setSourceName] = useState(t("SELECT"));
	const [sourceItem, setSourceItem] = useState("CUSTOM_DB_FIELD");
	const [action, setAction] = useState("INDEX");
	const [index, setIndex] = useState("CURRENT");
	const [showSourceNameOptions, setShowSourceNameOptions] = useState(false);
	const [sourceNameOptions, setSourceNameOptions] = useState([
		<MenuItem key={0} value={t("SELECT")}>
			{t("SELECT")}
		</MenuItem>,
	]);
	const [customDbDropDown, setCustomDbDropDown] = useState([
		<MenuItem key={0} value={t("SELECT")}>
			{t("SELECT")}
		</MenuItem>,
	]);
	const [pluginDropDown, setPluginDropDown] = useState([
		<MenuItem key={0} value={t("SELECT")}>
			{t("SELECT")}
		</MenuItem>,
	]);
	const tree = useSelector(
		(state) => state?.treeData?.outbound?.rightTree?.tree || []
	);
	const currentTab = useSelector(
		(state) => state?.treeData?.outbound?.rightTree?.currentTab || []
	);
	const [customDbValue, setCustomDbValue] = useState(t("SELECT"));
	const [pluginValue, setPluginValue] = useState(t("SELECT"));

	const outboundItemsOption = CONSTANT_RECORD_TYPE.OUTBOUND_ITEM.map(
		(ele, index) => {
			return (
				<MenuItem key={index} value={ele.value}>
					{ele.title}
				</MenuItem>
			);
		}
	);

	const actionsOption = ACTIONS.map((ele, index) => {
		return (
			<MenuItem key={index} value={ele.value}>
				{ele.title}
			</MenuItem>
		);
	});

	const indexOptions = INDEX.map((ele, index) => {
		return ele.value;
	});

	const handleIndex =  (value) => {
		if(INDEX.filter(e => e.value === value)?.length || !isNaN(value)) {
			valuesHandler(
				{
					MAPNAME: sourceName,
					RECORD_TYPE: sourceItem,
					ACTION: action,
					INDEX: value,
				},
				"OUTBOUND_ITEM"
			);
		}
		setIndex(value || '');
	} 
	useEffect(() => {
		
		const optionsArray = [{ title: t("SELECT"), value: t("SELECT") }];
		const dbOptionsArray = [{ title: t("SELECT"), value: t("SELECT") }];
		const pluginOptionArray = [{ title: t("SELECT"), value: t("SELECT") }];
		if (sourceType === "OUTBOUND_ITEM") {
			const valueToIcon = {
				CUSTOM_DB_FIELD: "QUERY",
				PLUGIN: "PLUGIN",
				SEQUENCE: "SEQUENCE",
				VARIABLE_COLLECTION: "VARIABLE_COLLECTION",
				VARIABLE: "VARIABLE",
			};
			// Finding in tree Dropdown value for Source Name in Template Properties.
			const tabArray =
				currentTab === "trailer"
					? ["header", "body", "trailer"]
					: ["header", "body"];
			tabArray?.map((tab) => {
				eachDeep(tree[tab], (obj) => {
					if (
						obj?.key && !obj?.hasOwnProperty("id") &&
						(obj?.ICON_DISPLAY === sourceItem ||
							(sourceItem === "CUSTOM_DB_FIELD" &&
								obj?.ICON_DISPLAY === "QUERY"))
					) {
						if (obj?.ICON_DISPLAY === valueToIcon.CUSTOM_DB_FIELD && obj?.TYPE === "QUERY") {
							const alreadyExist =
								dbOptionsArray.filter((ele) => ele.value === obj?.NAME)
									.length >= 1;
							if (!alreadyExist) {
								dbOptionsArray.push({ title: obj?.NAME, value: obj?.NAME });
							}

						}
						if (obj?.ICON_DISPLAY === valueToIcon.PLUGIN) {
							const alreadyExist =
								pluginOptionArray.filter((ele) => ele.value === obj?.NAME)
									.length >= 1;
							if (!alreadyExist) {
								pluginOptionArray.push({ title: obj?.NAME, value: obj?.NAME });
							}
						}
						if (valueToIcon.PLUGIN === sourceItem) {
							if (
								pluginValue &&
								(pluginValue !== t("SELECT") || !pluginOptionArray.filter((e) => e.value === pluginValue).length) &&
								obj?.NAME !== pluginValue
							)
								return;
							
							[...(sourceItem === "CUSTOM_DB_FIELD" ? customDbDefaultValues : []), ...(obj?.OUT_ARG || [])]?.forEach((ele) => {
								const argName = ele?.MAPNAME;
								const alreadyExist =
									optionsArray.filter((ele) => ele.value === argName).length >=
									1;
								
								if (!alreadyExist) {
									optionsArray.push({ title: argName, value: argName });
								}
							});
						}else if ("CUSTOM_DB_FIELD" === sourceItem) {
							if (
								customDbValue &&
								(customDbValue !== t("SELECT") || !dbOptionsArray.filter((e) => e.value === customDbValue).length) &&
								obj?.NAME !== customDbValue
							)
								return;
							
							[...(sourceItem === "CUSTOM_DB_FIELD" ? customDbDefaultValues : []), ...(obj?.OUT_ARG || [])]?.forEach((ele) => {
								const argName = ele?.MAPNAME;
								const alreadyExist =
									optionsArray.filter((ele) => ele.value === argName).length >=
									1;
								
								if (!alreadyExist) {
									optionsArray.push({ title: argName, value: argName });
								}
							});

						} else {
							const argName = obj?.NAME;
							const alreadyExist =
								optionsArray.filter((ele) => ele.value === argName).length >= 1;
							if (!alreadyExist) {
								optionsArray.push({ title: argName, value: argName });
							}
						}
					}
				});
			});

			const menuOptions = optionsArray.map((ele, index) => {
				return (
					<MenuItem key={index} value={ele.value}>
						{ele.title}
					</MenuItem>
				);
			});

			const dbMenuOptions = dbOptionsArray.map((ele, index) => {
				return (
					<MenuItem key={index} value={ele.value}>
						{ele.title}
					</MenuItem>
				);
			});

			const pluginOptions = pluginOptionArray.map((ele, index) => {
				return (
					<MenuItem key={index} value={ele.value}>
						{ele.title}
					</MenuItem>
				);
			});
			setCustomDbDropDown(dbMenuOptions);
			setSourceNameOptions(menuOptions);
			setPluginDropDown(pluginOptions);
			// if(sourceItem === valueToIcon.VARIABLE_COLLECTION){
			//   setAction('INDEX');
			//   setIndex('CURRENT')
			// }
		}
	}, [sourceType, sourceItem, customDbValue, currentTab, pluginValue]);

	useEffect(() => {
		if (sourceType === "OUTBOUND_ITEM") {
			setSourceItem(
				OutboundSourceItemOptions.filter((e) =>
					[node?.RECORD_TYPE, node?.SOURCE_TYPE].includes(e)
				)?.length
					? node?.RECORD_TYPE || node?.SOURCE_TYPE
					: "CUSTOM_DB_FIELD"
			);
			setSourceName(node?.MAPNAME || node?.LOOP_SOURCE_NAME || "SELECT");
			setAction(node?.ACTION || "INDEX");
			setIndex(node?.INDEX || "CURRENT");
			setCustomDbValue(node?.CUSTOM_DB_FIELD || t("SELECT"))
			setPluginValue(node?.PLUGIN_NAME || t("SELECT"))
		}
	}, [node?.key]);

	return (
		<Stack spacing={"10px"}>
			<DropDown
				disabled={disabled}
				label={t("LBL_SOURCE_ITEM")}
				options={outboundItemsOption}
				value={sourceItem}
				onChange={(e) => {
					setSourceItem(e.target.value);
					valuesHandler(
						{
							MAPNAME: t("SELECT"),
							RECORD_TYPE: e.target.value,
						},
						"OUTBOUND_ITEM"
					);
				}}
			/>
			{sourceItem === "CUSTOM_DB_FIELD" && (
				<DropDown
					disabled={disabled}
					label={t("CUSTOM_DB_FIELDS")}
					options={customDbDropDown}
					value={
						customDbDropDown.filter((e) => e.props.value === customDbValue)
							.length
							? customDbValue
							: t("SELECT")
					}
					onChange={(e) => {
						const value = e.target.value === t("SELECT") ? "" : e.target.value;
						setCustomDbValue(value);
						valuesHandler(
							{
								MAPNAME: sourceName,
								RECORD_TYPE: sourceItem,
								CUSTOM_DB_FIELD: value,
							},
							"OUTBOUND_ITEM"
						);
					}}
				/>
			)}

			{sourceItem === "PLUGIN" && (
				<DropDown
					disabled={disabled}
					label={t("LBL_PLUGIN_NAME")}
					options={pluginDropDown}
					value={
						pluginDropDown.filter((e) => e.props.value === pluginValue)
							.length
							? pluginValue
							: t("SELECT")
					}
					onChange={(e) => {
						const value = e.target.value === t("SELECT") ? "" : e.target.value;
						setPluginValue(value);
						valuesHandler(
							{
								MAPNAME: sourceName,
								RECORD_TYPE: sourceItem,
								PLUGIN_NAME: value,
							},
							"OUTBOUND_ITEM"
						);
					}}
				/>
			)}

			<DropDown
				disabled={disabled}
				label={
					sourceItem === "VARIABLE_COLLECTION"
						? t("VARIABLE_COLL")
						: t("LBL_SOURCE_NAME")
				}
				options={sourceNameOptions}
				value={
					sourceNameOptions.filter((e) => e.props.value === sourceName).length
						? sourceName
						: t("SELECT")
				}
				onChange={(e) => {
					setSourceName(e.target.value);
					valuesHandler(
						{
							MAPNAME: e.target.value,
							RECORD_TYPE: sourceItem,
							INDEX:
								sourceItem === "VARIABLE_COLLECTION"
									? index && action === "INDEX"
										? index
										: "CURRENT"
									: undefined,
							ACTION:
								sourceItem === "VARIABLE_COLLECTION"
									? action
										? action
										: "INDEX"
									: undefined,
							CUSTOM_DB_FIELD:
								sourceItem === "CUSTOM_DB_FIELD" &&
								customDbValue !== t("SELECT")
									? customDbValue
									: undefined,
							PLUGIN_NAME:
								sourceItem === "PLUGIN" &&
								pluginValue !== t("SELECT")
									? pluginValue
									: undefined,
						},
						"OUTBOUND_ITEM"
					);
					setAction(action ? action : "INDEX");
					setIndex(index ? index : "CURRENT");
				}}
			/>

			{sourceItem === "VARIABLE_COLLECTION" && (
				<>
					<DropDown
						disabled={disabled}
						label={t("LBL_ACTIONS")}
						options={actionsOption}
						value={action}
						onChange={(e) => {
							setAction(e.target.value);
							valuesHandler(
								{
									MAPNAME: sourceName,
									RECORD_TYPE: sourceItem,
									ACTION: e.target.value,
									INDEX:
										e.target.value === "INDEX" ? index || "CURRENT" : undefined,
								},
								"OUTBOUND_ITEM"
							);
						}}
					/>

					{action === "INDEX" && (
						// <DropDown
						//
						// 	options={indexOptions}
						// 	value={index}
						// 	onChange={(e) => {
						// 		setIndex(e.target.value);
						// 		valuesHandler(
						// 			{
						// 				MAPNAME: sourceName,
						// 				RECORD_TYPE: sourceItem,
						// 				ACTION: action,
						// 				INDEX: e.target.value,
						// 			},
						// 			"OUTBOUND_ITEM"
						// 		);
						// 	}}
						// />
						<Autocomplete
							disabled={disabled}
							size='small'
							variant='outlined'
							disablePortal
							options={indexOptions}
							
							value={index}
							inputValue={index}
							onChange={(event, newValue) => {
								handleIndex(newValue || "")
							}}
							onInputChange={(event, newInputValue) => {
								handleIndex(newInputValue || "")
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									label={t("LBL_INDEX")}
								/>
							)}
						/>
					)}
				</>
			)}
		</Stack>
	);
};

export default SourceTypeOutboundData;
